export const FAST_SHOT_MPH_THRESHOLD = 35;

export const FIREFIGHT_REACTION_THRESHOLD_MS = 600;
export const FIREFIGHT_MIN_SHOTS = 3;
